<template>
    <span>
      <b-tooltip label="View Available Integrations"
        position="is-bottom"
      >
        <b-button
          label="Setup instructions"
          type="is-primary"
          size="is-medium"
          icon-pack="fas"
          icon-right="arrow-right"
          outlined
          @click="showIntegrationsModal"
        />
    </b-tooltip>

</span>
</template>

<script>
import IntegrationsModal from './IntegrationsModal.vue';

export default {
    data() {
      return {}
    },
    props: {
        advisor: Object,
    },
    methods: {
      showIntegrationsModal() {
        this.$buefy.modal.open({
          parent: this,
          component: IntegrationsModal,
          hasModalCard: true,
          customClass: 'custom-class custom-class-2',
          trapFocus: true,
          props: {'advisor': this.advisor}
        });
      }
    }
}
</script>